export const mockAppsflyer = {
  inAppEvent: (_eventName: string, _eventValue?: Record<string, string>) => {
    // do nothing
  },
}
